import * as React from "react";
import { useState, useEffect} from "react"
import PageContainerWide from "../core/PageContainerWide";
import ModernCard from "../core/ModernCard";
import Breadcrumbs from "../core/Breadcrumbs";
import { jfetch } from "../../utils";
import { useParams, Link } from "react-router-dom";
import Swal from 'sweetalert2'
import Modal from "../core/Modal"
import toast from "../../utils/toast"
import Loader from "../core/Loader"
import useQuery from "../../hooks/useQuery";


interface IProps {
  userContext:any;
}

function QuotesIndex(props:IProps){
  const { calculator_id }:any = useParams();
  const [search, setSearch] = useState('')
  const [quotes, setQuotes] = useState(null)
  // const [visibleQuotes, setVisibleQuotes] = useState(null)
  const [calculator, setCalculator] = useState(null)
  const [global, setGlobal] = useState(true)
  const [orgOwns, setOrgOwns] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [company, setCompany] = useState('')
  const [contact, setContact] = useState('')
  const [email, setEmail] = useState('')
  const [id, setId] = useState('')
  const [order, setOrder] = useState('created_desc')
  const [maxPages, setMaxPages] = useState(0)
  let query = useQuery();
  const [savedSearch, setSavedSearch] = useState('')


  useEffect(() => {
    const result = getCookie('quotes_search')
    if(result){
      setSearch(result)
      getQuotes(1, 50, order, result)
    }
    else{
      getQuotes(1, 50)
    }
    
  }, [])

  function getQuotes(pagenum, per, order2=order, search2=search){
    setQuotes(null)
    let qparams:any = {
      pagenum:pagenum,
      per:per,
      order:order2
    }
    if(search2.trim() != ''){
      qparams.q = search2
    }
    jfetch.get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes`, qparams)
    .then((resp) => {
      setQuotes(resp.quotes)
      setQuotes(resp.quotes)
      setMaxPages(resp.meta.max_pages)
    })

    jfetch.get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}`)
    .then((resp) => {
      setCalculator(resp.calculator)
    })
  }



  const event = new Event('quote_change');
  useEffect(() => {
    window.document.dispatchEvent(event);
  }, [])

  useEffect(() => {
    if(calculator){
      setGlobal(calculator.global)
      setOrgOwns(calculator.organization_id == props.userContext.org.id)
    }
  }, [calculator])
  
  function filter(){
    if(search.trim() == ''){
      return
    }
    
    // if(search.trim() == 'denied'){
    //   const results = quotes.filter((quote) => quote.sold == 0)
    //   setQuotes(results)
    //   return
    // }

    // if(search.trim() == 'sold'){
    //   const results = quotes.filter((quote) => quote.sold == 1)
    //   setQuotes(results)
    //   return
    // }

    // if(search.trim() == 'pending'){
    //   const results = quotes.filter((quote) => quote.sold == null)
    //   setQuotes(results)
    //   return
    // }
    document.cookie = `quotes_search=${search}`;
    setSavedSearch(search)
    getQuotes(1, 50)
  
  }

  function clearSearch(){
    document.cookie = `quotes_search=delete;expires= Sun, 26 Jun 1994 18:00:00 UTC`;
    setSearch('')
    getQuotes(1, 50, order, '')
  }

  function keyCheck(key){
    if(key == 'Enter'){
      filter();
    }
  }

  function runSort(){
    // let current_quotes = [...visibleQuotes]
    getQuotes(1, 50)
  }



  function cloneQuote(){
    jfetch.post(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes/${id}/clone`, {
      quote: {
        id: id,
        company:company,
        contact: contact,
        email:email
      }
    })
    .then((resp) => {
      setQuotes(resp.quotes)
      setShowModal(false)
      toast.success(`Quote was cloned`)
    })
    .catch(() => {
      toast.error(`Unable to process submit`)
    })
  }

  function displayModal(quote){
    setCompany(quote.company)
    setContact(quote.contact)
    setEmail(quote.email)
    setId(`${quote.id}`)
    setShowModal(true)
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }


  
  return (
    <div className="quotes-index">
      <PageContainerWide>
        <Breadcrumbs
          crumbs={[
            {
              label: "Pricing Quote Dashboard",
              route: "/quote_calculator",
              routerLink: true,
            },
            { label: `Quotes` }
          ]}
        /> 
        <div className="row">
          <div className="col-lg-9">
            <input type="text" placeholder='Search Quotes...' value={search} onChange={(e) => setSearch(e.target.value)} onKeyUp={(e) => keyCheck(e.key)} style={{marginRight:'10px', display:'inline-block'}}  />
            <button onClick={filter} className="btn btn-primary btn-sm" style={{verticalAlign:'top', marginRight:'10px'}}>
              <i className="fa fa-search" style={{marginRight:'5px'}} /> Search
            </button>
            <button onClick={clearSearch} className="btn btn-primary btn-sm" style={{verticalAlign:'top'}}>
              <i className="fa fa-refresh" style={{marginRight:'5px'}} />View All
            </button>
            <div style={{display:'inline-block', marginLeft:'30px', verticalAlign:'top'}}>
              <label>Sort By</label>
              <select value={order} onChange={(e) => setOrder(e.target.value)}  className="form-control" style={{width:'inherit', display:'inline-block', marginLeft:'5px'}}>
                <option value="created_desc">Date: New-Old </option>  
                <option value="created_asc">Date: Old-New </option>  
                <option value="company_asc">Company: A-Z </option>  
                <option value="company_desc">Company: Z-A </option>  
                <option value="project_asc">Project Price: Low-High</option>
                <option value="project_desc">Project Price: High-Low</option>
                <option value="haas_asc">HAAS Price: Low-High</option>
                <option value="haas_desc">HAAS Price: High-Low</option>                
              </select> 
              <button onClick={runSort} className="btn btn-primary btn-sm" style={{verticalAlign:'top', marginLeft:'5px'}}>
                <i className="fa fa-sort" style={{marginRight:'5px'}} /> Order
            </button>
            </div>            
          </div>
          <div className="col-lg-3 text-right">              
            <div>
              <Link to={`/quote_calculator/${calculator_id}/quote_new/`}>
                <button className="btn btn-primary btn-sm">
                  <i className="fa fa-plus" style={{marginRight:'5px'}} /> New Quote
                </button>
              </Link>
              {/* show edit when calculator is not global OR calculator is global and belongs to this users organinization */}
              {((!global) || (global && orgOwns))  && ( 
                <Link to={`/quote_calculator/edit/${calculator_id}`}>
                  <button className="btn btn-primary btn-sm" style={{marginLeft:'10px'}}>
                    <i className="fa fa-pencil" style={{marginRight:'5px'}}/> Edit Calculator
                  </button>
                </Link>
              )} 
            </div>
          </div>
        </div>
        <ModernCard>
          <div className="row" style={{paddingTop:'10px', paddingBottom:'10px'}}>
              <div className="col-lg-12">
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li>
                      <a href="#" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                    {[...Array(maxPages)].map((x, i) => {
                      return (
                        <li key={i}>
                          <a onClick={() => getQuotes(i+1, 50)} style={{cursor:'pointer'}}>{i+1}</a>
                        </li> 
                      )
                    })}
                    <li>
                      <a href="#" aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          <div className="row titles" style={{paddingTop:'10px', paddingBottom:'10px'}}>       
            <div className="col-lg-2">
              id
            </div>          
            <div className="col-lg-2">
              Company
            </div>
            <div className="col-lg-2">
              Contact
            </div>
            <div className="col-lg-2">
              Project/HAAS Price 
            </div>          
            <div className="col-lg-2">
              Created
            </div>
            <div className="col-lg-2">
              modify
            </div>
          </div>
          {quotes == null && (
            <Loader/>
          )}
          {quotes && quotes.map((q) => (
            <Quote 
              quote={q} 
              key={q.id} 
              calculator_id={calculator_id} 
              userContext={props.userContext} 
              updateQuotes={(quotes) => setQuotes(quotes)} 
              displayModal={displayModal}
              savedSearch={savedSearch}
            />
          ))}

        </ModernCard>
      </PageContainerWide>

      <Modal
          title={"Clone Quote"}
          open={showModal}
          close={() => setShowModal(false)}
          submittable={true}
          isLarge={false}
          disallowClickOutside={true}
          submitText="Clone"
          onSubmit={cloneQuote}
        >
          <div className="row">
            <div className="col-lg-9">
              <div className="form-group">
                <label>Company Name</label>
                <input onChange={(e) => setCompany(e.target.value)} value={company} type="text" className="form-control" />
              </div>
              <div className="form-group">
                <label>Contact Name</label>
                <input onChange={(e) => setContact(e.target.value)} value={contact} type="text" className="form-control" />
              </div>
              <div className="form-group">
                <label>Contact Email</label>
                <input onChange={(e) => setEmail(e.target.value)} value={email} type="text" className="form-control" />
              </div>
            </div>
          </div>
        </Modal>
    </div>
  )
}


interface quoteProps{
  quote:{
    id:number;
    company: string;
    contact: string;
    created_at: string;
    created_by: string;
    created_by_id: number;
    time_ago: string;
    haas_price: string;
    project_price: string;
    email:string;
    sold:boolean;

  }
  calculator_id: string;
  userContext: any;
  updateQuotes: Function;
  displayModal: Function;
  savedSearch: string;
}

function Quote(props:quoteProps){
  let quote_link_edit = `/quote_calculator/${props.calculator_id}/quote_edit/${props.quote.id}/`
  let quote_link_show = `/quote_calculator/${props.calculator_id}/quote_show/${props.quote.id}/`
  if(props.savedSearch != ''){
    quote_link_edit += `?search=${props.savedSearch}`
    quote_link_show += `?search=${props.savedSearch}`
  }
  return (
    <div className="row data">
      <div className="col-lg-2">
        {props.quote.id}
      </div>      
      <div className="col-lg-2">
        {props.quote.sold == null && (
          <i className="fa fa-refresh" style={{marginRight: '5px', color:'#2291fc'}} />
        )}
        {props.quote.sold == true && (
          <i className="fa fa-check" style={{marginRight: '5px', color:'green'}} />
        )}        
        {props.quote.sold == false && (
          <i className="fa fa-times" style={{marginRight: '5px', color:'#d0021b'}} />
        )}        
        {props.quote.company}
      </div>
      <div className="col-lg-2">
      {props.quote.contact}
      </div>      
      <div className="col-lg-2">     
        {props.quote.project_price} / {props.quote.haas_price}
      </div>  
      <div className="col-lg-2">
        {props.quote.created_at} <br/>
        <small>{props.quote.time_ago}</small> <br/>
        <small>{props.quote.created_by}</small>
      </div>
      <div className="col-lg-2">
        <Link to={quote_link_edit} >
          <i className="fa fa-pencil"/>
        </Link>        
        <a style={{marginLeft:'8px', cursor:'pointer'}} onClick={() => props.displayModal(props.quote)}>
          <i className="fa fa-files-o" />
        </a>  
        <Link to={quote_link_show} >
          <i className="fa fa-eye" style={{marginLeft:'8px'}} />
        </Link>                
        <a 
          style={{color:'#d0021b', marginLeft:'8px', cursor:'pointer'}}

          onClick={() => {
            Swal.fire({
              title: '<h3 style="font-size:28px;">Are you sure?<h3>',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              customClass: { confirmButton: 'btn btn-primary btn-small', closeButton: 'btn btn-danger btn-small'},
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.value) {
                jfetch
                .delete(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${props.calculator_id}/quotes/${props.quote.id}`)
                .then((resp) => props.updateQuotes(resp.quotes))
              }
            })
          }}
        >
          <i className="fa fa-trash"/>
        </a>
      </div>
    </div>
  )
}

export default QuotesIndex


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuotesIndex.tsx